import { render, staticRenderFns } from "./record.vue?vue&type=template&id=b54b2ca0"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style0 from "./record.vue?vue&type=style&index=0&id=b54b2ca0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_d02125917f7c66a571cdcbfa3dd68341/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b54b2ca0')) {
      api.createRecord('b54b2ca0', component.options)
    } else {
      api.reload('b54b2ca0', component.options)
    }
    module.hot.accept("./record.vue?vue&type=template&id=b54b2ca0", function () {
      api.rerender('b54b2ca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coupon/record.vue"
export default component.exports